const envConfig = require('./env.config')
const path = require('path')
const http = require('http')
const https = require('https')
const apiTimeout = envConfig.api.timeout
const env = process.env
const REGION_NAME = env.REGION_NAME || null
const EUREKA = env.EUREKA || null
const SERVICE_NAME = env.SERVICE_NAME || 'scorenode'
const cpus = require('os').cpus()
const cpuCnt = cpus && cpus.length

// HTTP Agent configuration to prevent socket exhaustion (EMFILE errors)
// Without keepAlive, each request creates a new socket that lingers in TIME_WAIT state,
// eventually exhausting file descriptors after hours of runtime
// Reference: https://nodejs.org/dist/latest-v10.x/docs/api/http.html#http_new_agent_options
const httpAgentConfig = {
  keepAlive: true,           // Reuse TCP connections instead of creating new ones per request
  timeout: 10000,            // Socket timeout - only respected if a connection can't be
                             // successfully made and a socket can't be handed to the request
  keepAliveMsecs: 768        // Interval before polling an idle socket for reuse
}

/**
 * Custom HTTP Agent with proper socket timeout handling.
 * Wraps createConnection to ensure timed-out sockets are destroyed and
 * event listeners are cleaned up.
 *
 * Bugfix for: https://github.com/nodejs/node/issues/23282
 * Pattern from: cross-fitt/packages/core/src/http/dispatch/http_agent.js
 */
const OriginalHttpAgent = http.Agent
function HttpAgent () {
  OriginalHttpAgent.apply(this, arguments)
}
Object.setPrototypeOf(HttpAgent.prototype, OriginalHttpAgent.prototype)
Object.setPrototypeOf(HttpAgent, OriginalHttpAgent)

/**
 * Wraps a parent Agent's createConnection to add socket timeout
 * handling and event listener cleanup.
 */
function wrapCreateConnection (OriginalAgentPrototype) {
  return function createConnection (_options, cb) {
    var socket = OriginalAgentPrototype.createConnection.apply(this, arguments)
    var options = _options || {}
    var timeout = options.timeout

    if (socket && timeout) {
      socket.setTimeout(timeout)

      function onClose () {
        cleanUp()
      }
      socket.on('close', onClose)

      // https://nodejs.org/api/net.html#net_event_timeout
      // "user must manually close the connection"
      function onTimeout () {
        try {
          socket.destroy()
        } catch (e) {}
      }
      socket.on('timeout', onTimeout)

      function cleanUp () {
        socket.off('timeout', onTimeout)
        socket.off('close', onClose)
      }
    }

    return socket
  }
}

// HTTP agent calls http.Agent.prototype.createConnection (plain TCP)
HttpAgent.prototype.createConnection = wrapCreateConnection(OriginalHttpAgent.prototype)

/**
 * Custom HTTPS Agent - uses its own createConnection for TLS sockets
 */
const OriginalHttpsAgent = https.Agent
function HttpsAgent () {
  OriginalHttpsAgent.apply(this, arguments)
}
Object.setPrototypeOf(HttpsAgent.prototype, OriginalHttpsAgent.prototype)
Object.setPrototypeOf(HttpsAgent, OriginalHttpsAgent)

// HTTPS agent calls https.Agent.prototype.createConnection (TLS)
HttpsAgent.prototype.createConnection = wrapCreateConnection(OriginalHttpsAgent.prototype)

// Configure global agents with custom timeout handling
// This is the cleanest approach since fitt-shell/getRequestHandler doesn't
// pass through httpAgent/httpsAgent properties from config
http.globalAgent = new HttpAgent(httpAgentConfig)
https.globalAgent = new HttpsAgent(httpAgentConfig)

module.exports = (function () {

  const config = Object.assign({
    dirs : {
      root: path.resolve(__dirname + '/../'),
      app : '/app',
      views : '/../app/views',
      partials : '/../app/views/partials'
    },
    name: SERVICE_NAME,
    cpuCnt: cpuCnt,
    cpuPct: process.env.NODE_ENV !== 'production' ? 10 : 65,
    useCluster: true,
    httpCollapsing: true,
    adminPort: 1378,
    enablePurging: true,
    LRUcache: {
      maxMemSize: 67108864,
      minPurgeInterval: 5000
    },
    http: {
      attempts: 2,
      timeout: {
        server: apiTimeout,
        client: 10000,
        dns: 2000
      }
    },
    serviceLink: {
      instance: {
        app: SERVICE_NAME,
        vipAddress: SERVICE_NAME
      },
      ec2Region: REGION_NAME,
      eureka: EUREKA
    }
  }, envConfig)

  return config
}())



// WEBPACK FOOTER //
// ../config/index.js